import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal} from 'antd';
import { checkUserAuthorization, fetchSpacesStatus, getCalenderList, getFilteredSpaces, setSelectedCalendar, unSyncGoogleCalendarFromHost } from './HostDashboardActions';
import decode from "jwt-decode";
import { Grid, Cell } from 'react-md';
import {
    Link, Switch,
    Route, useRouteMatch, Redirect
} from "react-router-dom";

import Spaces from './Spaces';
import { ADMIN, USER } from '../Common/constants';
import SpaceDetails from './SpaceDetails';
import { showErrorMessageCalendar, showSuccessMessageCalendar } from '../SpaceListing/Common/Common';
import { alertError, alertSuccess } from '../../helper/AlertNotification';
import AdminDashboardLayout from '../Common/AdminDashboardLayout/AdminDashboardLayout';
import info from "../../assets/images/calendarSync/info-sync.png"
const SpaceContainer = () => {
    const isGuest = (authDetails) => authDetails ? decode(authDetails)?.authorities?.[0] === USER : true;
    const authDetails = useSelector((state) => state?.auth?.loginDetails?.data?.token || null);
    const authToken = useSelector(state => state?.auth?.loginDetails?.data?.token);
    const calendarAuthStatus = useSelector(state => state?.hostDashboard?.calendar?.authStatus || {})
    const [isUnlinkModalVisible, setIsUnlinkModalVisible] = useState(false);

    const { path, url } = useRouteMatch();
    const dispatch = useDispatch();
    const status = ['ALL', 'ACTIVE', 'PENDING', 'INACTIVE', 'DECLINED', 'DRAFT'];
    const isFetching = useSelector(state => state?.hostDashboard?.fetching);

    const [visibleComingSoon, setVisibleComingSoon] = useState(false);
    const [userType, setUserType] = useState(null);
    const [statusAllSelected, setStatusAllSelected] = useState(true);
    const [bookingStatus, setBookingStatus] = useState('');
    const [clickedStatus, setClickedStatus] = useState('ALL');
    const [pageCount, setPageCount] = useState(1);
    const [divFocus, setDivFocus] = useState(false);
    
    const [scrolledPosition, setScrolledPosition] = useState(0);
    const [isBackClicked, handleBackClicked] = useState(false)
    const pageSize = 10;

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': authToken
    }

    useEffect(() => {
        window.scrollTo(0,0)
        dispatch(getFilteredSpaces({ page: 1, size: pageSize }, headers))
        dispatch(fetchSpacesStatus());
        dispatch(checkUserAuthorization())
    }, []);

    useEffect(()=>{
        if(calendarAuthStatus?.status){
        dispatch(getCalenderList())
    }
    },[calendarAuthStatus?.status])

    const handleStatusSelection = (status) => {
        if (status) {
            setPageCount(value => 1);
            dispatch(getFilteredSpaces({ page: 1, size: pageSize, status: status }, headers));
        }
        else
            dispatch(getFilteredSpaces({ page: 1, size: pageSize }, headers));
    };
    const showUnlinkModal = () => {
        setIsUnlinkModalVisible(true);
      };
    
      const handleSaveOk = () => {
        dispatch(unSyncGoogleCalendarFromHost((success)=>{
            if(success){
                dispatch(setSelectedCalendar(null))
                setIsUnlinkModalVisible(false);
                dispatch(checkUserAuthorization())
                alertSuccess('Calendar Unlinked', 'Google Calendar disconnected from MillionSpaces.');
            }else{
                alertError('Unlink Failed', 'Unable to disconnect Google Calendar. Please try again.');
            }
        }))
      };
    
      const handleSaveCancel = () => {
        setIsUnlinkModalVisible(false);
      };

    return (
      <AdminDashboardLayout>
        <div>
          <div className={divFocus && 'space-main-wrap'} onClick={() => setDivFocus(false)}></div>
          <Switch>
            <Route path={`${path}/:status/:spaceId`}>
              <SpaceDetails handleBackClicked={handleBackClicked} />
            </Route>
            <Route path={`${path}/:status`}>
              <Spaces
                divFocus={divFocus}
                setDivFocus={setDivFocus}
                bookingStatus={bookingStatus}
                setClickedStatus={setClickedStatus}
                scrolledPosition={scrolledPosition}
                setScrolledPosition={setScrolledPosition}
                handleBackClicked={handleBackClicked}
                isBackClicked={isBackClicked}
                showUnlinkModal={showUnlinkModal}
                calendarAuthStatus={calendarAuthStatus}
              />
            </Route>
            <Route path={`*`}>
              <Redirect to={`${url}/all`} />
            </Route>
          </Switch>
        </div>
        <Modal
          title="Unlink Calendar"
          wrapClassName="custom-unlink-calendar-modal"
          visible={isUnlinkModalVisible}
          onOk={handleSaveOk}
          onCancel={handleSaveCancel}
          okText="Unlink"
          cancelText="Cancel"
          centered
          cancelButtonProps={{ className: 'custom-cancel-button-unlink' }}
          okButtonProps={{ className: 'custom-unlink-button-confirm' }}
        >
          <div className="unlink-calendar-content">
            <p className="modal-text-save-head custom-modal-text">
                Are you sure want to unlink your Google Calendar from Millionspaces?
            </p>
            
            <div className="unlink-info-box">
                <p className="info-title">By unlinking your Google Calendar:</p>
                <ul className="info-list">
                    <li>Event synchronization between all the spaces and your Google Calendars will stop.</li>
                    <li>Existing events in your Google Calendar will remain unchanged.</li>
                    <li>You will need to resync from scratch if you wish to connect the calendars again.</li>
                </ul>
            </div>
          </div>
        </Modal>
      </AdminDashboardLayout>
    );
};

export default SpaceContainer;